var insertResults = require('./insert-results');

module.exports = function (apiEndpoint) {
    var $page = $('#landing-page-with-search');

    if(!$page.length) {
        return;
    }

    var $filtersClearAllCTA = $page.find('.dropdown-filters__clear');

    $filtersClearAllCTA.unbind('click');

    $page.on('click', 'a.dropdown-filters__clear', function (e) {
        e.preventDefault();

        clearAll();
    });

    var clearAll = function () {
        window.page = 1;
        window.regions = [];
        window.topics = [];
        window.contentLabels = [];
        window.topicMatchType = '';

        if (window.$topicContentDesktopContent) {
            window.$topicContentDesktopContent.find('input[type="checkbox"]').attr('checked', false);
            window.$topicContentDesktopContent.find('.popover__cta--reset').addClass('popover__cta--hidden');
        }

        if (window.$regionContentDesktopContent) {
            window.$regionContentDesktopContent.find('input[type="checkbox"]').attr('checked', false);
            window.$regionContentDesktopContent.find('.popover__cta--reset').addClass('popover__cta--hidden');
        }

        if (window.$contentLabelContentDesktopContent) {
            window.$contentLabelContentDesktopContent.find('input[type="checkbox"]').attr('checked', false);
            window.$contentLabelContentDesktopContent.find('.popover__cta--reset').addClass('popover__cta--hidden');
        }

        $('.dropdown-filters').removeClass('dropdown-filters--active');
        $('.dropdown-filter').removeClass('dropdown-filter--active');

        insertResults(apiEndpoint);
    };
};